import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';

let firstRender = false
const Rating = inject("authenStore")(observer((props) => {
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [optionStatus, setOptionStatus] = useState([])

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status")
        .then((res: any) => {
          let common_status = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          setOptionStatus(common_status)
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  return <FormMaster
    title="ข้อมูลคะแนน"
    tableConfig={{
      key: "rate_id",
      apiPath: "rate/list",
      allowDelete: {
        visible: false,
        key: "rate_id",
        apiPath: "rate/delete"
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: "ลำดับ",
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'rate_name',
          caption: "หัวข้อ",
          allowFiltering: true
        },
        {
          dataField: 'point',
          caption: "คะแนน",
          allowFiltering: true
        },
        {
          dataField: 'status_name',
          caption: "สถานะ",
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: "แก้ไขโดย"
        }
      ],
      exportExcel: {
        fileName: 'ข้อมูลคะแนน',
        columnConfig: [
          { label: 'ลำดับ', value: 'no' },
          { label: 'หัวข้อ', value: 'rate_name' },
          { label: 'คะแนน', value: 'point' },
          { label: 'สถานะ', value: 'status_name' },
          { label: 'แก้ไขโดย', value: 'updated_by' }
        ]
      }
    }}
    formData={{
      rate_name: "",
      point: 0,
      status: "Y"
    }}
    modalConfig={{
      screenName: "rating",
      visible: true,
      title: "ข้อมูลคะแนน",
      required: ["rate_name", "point"],
      fieldTypeNumber: ["point"],
      paramName: "rate_id",
      apiPath: {
        "get": '',
        "post": 'rate/add',
        "put": 'rate/update'
      },
      elements: [
        {
          fieldName: "rate_name",
          label: "หัวข้อ",
          placeholder: "หัวข้อ",
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "point",
          label: "คะแนน",
          placeholder: "คะแนน",
          required: true,
          inputType: "number",
          isOneRow: true
        },
        {
          showSearch: false,
          fieldName: "status",
          label: "สถานะ",
          inputType: "select",
          required: true,
          defaultValue: "Y",
          options: optionStatus
        }
      ]
    }}
  />
}))

export default Rating